import React from "react";
import { withTranslation } from "react-i18next";
import { LocalStorageService, ClientContractService, WorkflowService, WorkflowMessagesService } from "../../../services";
import { changeFormatNumberToShow, getNavigatorTimezone } from "../../../utils";
import { ContractRequestStatusView } from "../../views";

class ContractRequestStatusAction
extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      user: {},
      token:'',
      shouldRefresh: false,
      message: "",
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,
      showWarningRequesting: false,
      contract: {},
      workflowExecutionInfo: {},
      questions:[],
      path:'/',
      clientContractId: '',
      workflowExecutionId: '',
      errorMessage : '',
      workflowContract:{},
      workflowNegotiation:{},
      membersChat: []
    };
  }

  
  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  clientContractService = new ClientContractService(this.url);
  workflowService = new WorkflowService(this.url);
  workflowMessagesService = new WorkflowMessagesService(this.url);

  clientContractId = ""
  timezone = getNavigatorTimezone()

  async componentDidMount() {
    this.setState({
      loading: true
    })

    try {
      let location = this.props.location
      let search = (location && location.search) ? location.search : ''
      let contractId = search ? search.split('?')[1] : ''
      this.clientContractId = contractId || null
      this.props.history.replace({ pathname: '/digital-contract/detail-contract' });
  
      this.token = this.localStorageService.getLocalStorageItem("token").idToken;
      this.user = this.localStorageService.getLocalStorageItem("user");
      this.getContarctData()
      this.getQuestionsForcontract()  
      this.getWorkflowContract()
      this.getWorkflowNegotiation()
  
      this.setState({ 
        token: this.token,
        user: this.user
      });
    } catch (error) {
      this.setState({
        loading: false
      })

      this.toggleErrorRequesting(true, 'Ocurrió un erro al consultar la información el contrato')
      setTimeout(() => {
        this.toggleErrorRequesting()
        this.props.changeRoute('home')
      }, 3000)
    }

  }

  forceRefresh = () => {
    this.setState(({ shouldRefresh }) => ({ shouldRefresh: !shouldRefresh }));
  };

  //Function loading dialog
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  //Function completed dialog

  toggleCompletedRequesting = (
    value,
    message
    ) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: "",
          });
        }, 4000);
      }
    );
  };

  //Funtion error dialog
  toggleErrorRequesting = (value, message) => {
    this.setState(
      {
        showErrorRequesting: value,
        errorMessage: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showErrorRequesting: false,
            errorMessage: "",
          });
        }, 4000);
      }
    );
  };

  //Funtion warning dialog
  toggleWarningRequesting = (value, message) => {
    this.setState(
      {
        showWarningRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showWarningRequesting: false,
            message: "",
          });
        }, 4000);
      }
    );
  };

  async getContarctData (){
    let clientContractId = this.clientContractId
    this.setState({clientContractId: clientContractId})
    try {
      let contract = await this.clientContractService.getContractById(clientContractId, this.token)
      if(contract && contract.data && Number(contract.statusCode) === 200){
        this.setState({
          contract: contract.data
        })
      }else{
        this.setState({
          loading: false
        })
        this.toggleErrorRequesting(true, 'Ocurrió un erro al consultar el contrato')
        setTimeout(() => {
          this.toggleErrorRequesting()
          this.props.changeRoute('home')
        }, 3000)
      }
    } catch (error) {
      this.setState({
        loading: false
      })
      this.toggleErrorRequesting(true, 'Ocurrió un erro al consultar el contrato')
      setTimeout(() => {
        this.toggleErrorRequesting()
        this.props.changeRoute('home')
      }, 3000)
    }
  } 

  async getQuestionsForcontract() {
    let messageError = 'Ocurrió un error al consultar las preguntas'
    let clientContractId = this.clientContractId;
    try {
      let questions = await this.clientContractService.getQuesitonsForContractById(clientContractId, this.token);
      if (questions && questions.data && Number(questions.statusCode) === 200) {
        let allQuestions = questions.data.map((question) => {
          let format = (question.formatVariable && question.formatVariable.groupName && question.formatVariable.groupName !== 'none') ? question.formatVariable.groupName : 'text' 
          let value = ''
          if(format === 'number'){
            value = (question.answerNumber) ?  changeFormatNumberToShow(question.answerNumber,  question.formatVariable.id) : ''
          }else if(format === 'date'){
            value = question.answerDate
          }else{
            value = (question.answerString) ? question.answerString : ''
          }
          
          question.disabled = false
          question.isForContractor = true
          question.format = format
          question.value = value
          return question
        })

        this.setState({
          questions: allQuestions
        })
      } else {
        this.setState({
          loading: false
        })
        this.toggleErrorRequesting(true, 'Ocurrió un erro al consultar el contrato')
        setTimeout(() => {
          this.toggleErrorRequesting()
          this.props.changeRoute('home')
        }, 3000)
      }
    } catch (error) {
      this.setState({
        loading: false
      })
      this.toggleErrorRequesting(true, 'Ocurrió un erro al consultar el contrato')
      setTimeout(() => {
        this.toggleErrorRequesting()
        this.props.changeRoute('home')
      }, 3000)
    }
  }

  async getWorkflowContract () {
    let solicitudeId = this.clientContractId
    let workflowId = 4
    
    try {
      let workflow = await this.workflowService.getWorkflowBySolicitudeIdAndWorkflowId(solicitudeId, workflowId, this.token)
      if (workflow && workflow.data && Number(workflow.statusCode) === 200) {
        this.getMessages(workflow.data)
        this.setState({
          workflowContract:workflow.data
        })
      }
    } catch (error) {
      this.setState({
        loading: false
      })
      this.toggleErrorRequesting(true, 'Ocurrió un erro al consultar el contrato')
      setTimeout(() => {
        this.toggleErrorRequesting()
        this.props.changeRoute('home')
      }, 3000)
    }
  }

  async getWorkflowNegotiation () {
    let solicitudeId = this.clientContractId
    let workflowId = 6
    
    try {
      let workflow = await this.workflowService.getWorkflowBySolicitudeIdAndWorkflowId(solicitudeId, workflowId, this.token)
      if (workflow && workflow.data && Number(workflow.statusCode) === 200) {
        this.setState({
          workflowNegotiation: workflow.data
        })
      }
    } catch (error) {
      this.setState({
        loading: false
      })
      this.toggleErrorRequesting(true, 'Ocurrió un erro al consultar el contrato')
      setTimeout(() => {
        this.toggleErrorRequesting()
        this.props.changeRoute('home')
      }, 3000)
    }
  }


  getMessages = async (workflow) => {
    let errorMessages = "Ocurrió un error al consultar los mensajes";
    let workflowExecutionId = workflow.id

    try {
      //Get message and members chat
      let workflowMessage =
        await this.workflowMessagesService.getWorkFlowExecutionMessage(
          workflowExecutionId,
          this.timezone,
          this.token
        );
      if (
        workflowMessage &&
        workflowMessage.data &&
        Number(workflowMessage.statusCode) === 200
      ) {

        //Filter out duplicated members
        let membersChat = workflowMessage.data.workflowExecutionMembers.filter((member, index) =>
          workflowMessage.data.workflowExecutionMembers.findIndex((item) => item.email === member.email) === index
        );
        //users chat
        membersChat.map((member) => {
          member.id = member.workflowExecutionMemberId;
          member.avatarUrl = member.profilePicture;
          member.name = member.firstName + " " + member.firstLastName;
          member.avatarAltText = member.firstName + " " + member.firstLastName;
          return membersChat;
        });

        this.setState({
          membersChat: membersChat,
          loading: false
        });
        this.toggleLoadingRequesting(false);
      } else {
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true, errorMessages);
        setTimeout(() => {
          this.toggleErrorRequesting(false);
          this.props.history.push("/");
        }, 3000);
      }
    } catch (error) {
      this.setState({
        loading: false
      })
      this.toggleErrorRequesting(true, 'Ocurrió un erro al consultar el contrato')
      setTimeout(() => {
        this.toggleErrorRequesting()
        this.props.changeRoute('home')
      }, 3000)
    }
  };


  render() {
    return (
        <ContractRequestStatusView
          showLoadingRequesting = {this.showLoadingRequesting}
          toggleLoadingRequesting = {this.toggleLoadingRequesting} 
          showCompletedRequesting = {this.showCompletedRequesting}
          toggleCompletedRequesting = {this.toggleCompletedRequesting} 
          showErrorRequesting = {this.showErrorRequesting}
          toggleErrorRequesting = {this.toggleErrorRequesting}
          path = {this.state.path}
          {...this.state}
          {...this.props}
        />
    );
  }
}

export default withTranslation()(ContractRequestStatusAction);